import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { processMarkdown } from '@core/tellent-assistant-util';

@Component({
  selector: 'tellent-assistant-text-part',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="body" [innerHTML]="html()"></div>`,
  styleUrls: ['./text-part.component.less'],
})
export class TellentAssistantTextPartComponent {
  public readonly content = input.required<string>();
  public readonly done = input.required<boolean>();
  private readonly sanitizer = inject(DomSanitizer);
  protected readonly html = computed<SafeHtml>(() =>
    this.sanitizer.bypassSecurityTrustHtml(processMarkdown(this.content())),
  );
}
